/**
 * Load fonts Mackinac (serif) and Noto Sans (body sans)
 */
import 'static/fonts/mackinac.css';
import 'static/fonts/notoSans.css';

import { Environment, getEnvironment, initMonitoring } from '@color/lib';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';

import { getMonitoringConfig } from 'lib/util/monitoring/config';

import { BaseApp } from './ui/App/BaseApp';

const environment: Environment = getEnvironment();
initMonitoring(getMonitoringConfig(environment));

export async function initializeReactApp() {
  const ConfiguredBaseApp = await BaseApp();

  /** **********************
   * TODO (FG-71): We would like to replace the old ReactDOM.render pattern with
   * the new ReactDOM.createRoot. That would let us take advantage of the new
   * features in React 18.
   *
   * HOWEVER! We *CANNOT* safely do that until we can make sure that
   * problems like the one described here are all resolved:
   * https://getcolor.atlassian.net/wiki/spaces/SWEng/pages/3071541268/Deep+dive+React+18+Formik+freeze+bug
   * *********************** */

  // 🚨🚨🚨 LEAVE THIS AS ReactDOM.render! See comment above. 🚨🚨🚨
  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(
    <StrictMode>
      <ConfiguredBaseApp />
    </StrictMode>,
    document.getElementById('root') as HTMLElement
  );
}
